import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import api, { createUrlParams } from "../client"
import { GetOrdersRequestQuery, OrdersResponseData } from "../types/order"

const FIVE_MINUTES_IN_MS = 1000 * 60 * 5

const getData = async (getOrdersRequestQuery: GetOrdersRequestQuery) => {
  const { data } = await api.get(`/orders${createUrlParams(getOrdersRequestQuery)}`)
  return data
}

export const useOrders = (getOrdersRequestQuery: GetOrdersRequestQuery)
  : QueryObserverBaseResult<OrdersResponseData> => {
  const { data, ...props } = useQuery<OrdersResponseData>(
    queryKeys.ORDERS(getOrdersRequestQuery),
    () => getData(getOrdersRequestQuery),
    { refetchInterval: FIVE_MINUTES_IN_MS }
  )
  return { data, ...props }
}
